import React from 'react';
import { DropdownContext } from './DropdownContext';

export const useDropdown = () => {
  const context = React.useContext(DropdownContext);

  if (!context) {
    throw new Error(
      'dropdownHook hook has to be used inside DropdownContext.Provider.',
    );
  }

  return context;
};
